import { render, staticRenderFns } from "./ResetRequestForm.vue?vue&type=template&id=01805a62&scoped=true&"
import script from "./ResetRequestForm.vue?vue&type=script&lang=ts&"
export * from "./ResetRequestForm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetRequestForm.vue?vue&type=style&index=0&id=01805a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01805a62",
  null
  
)

export default component.exports